export default __webpack_public_path__ + "static/media/questions-xl-2x.1179816a.png";